"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const cronstrue_1 = __importDefault(require("cronstrue"));
const CardStyles_1 = require("../card/CardStyles");
require("./InstructionsCheckin.scss");
const constants_1 = require("../../../../../assets/constants/constants");
const InstructionsCheckin = ({ reserve }) => {
    const { checkInInstructions } = reserve;
    const [hourLimit, setHourLimit] = (0, react_1.useState)('14:30:00');
    (0, react_1.useEffect)(() => {
        const convertedCron = cronstrue_1.default.toString(constants_1.BOOKING_TIME_CHECKIN_LIMIT, {
            use24HourTimeFormat: true,
            locale: 'en',
        });
        setHourLimit(convertedCron.replace('At', ''));
    }, []);
    return (react_1.default.createElement("div", { className: "Instruction-Checkin-Container" },
        react_1.default.createElement("div", { className: "instructions-title" },
            react_1.default.createElement(CardStyles_1.Title, null, "Instru\u00E7\u00F5es de Check-in")),
        checkInInstructions && checkInInstructions.showCheckInInstructions ? (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement("div", { className: "instructions-fields" },
                react_1.default.createElement("span", null, "C\u00F3digo da reserva:\u00A0"),
                react_1.default.createElement("span", { className: "bold" }, checkInInstructions.reservationCode)),
            react_1.default.createElement("div", { className: "instructions-fields" },
                react_1.default.createElement("span", null, "Endere\u00E7o:\u00A0"),
                react_1.default.createElement("span", { className: "bold" }, checkInInstructions.address)),
            react_1.default.createElement("div", { className: "instructions-fields" },
                react_1.default.createElement("span", null, "C\u00F3digo de acesso ao apartamento (chave eletr\u00F4nica):\u00A0"),
                react_1.default.createElement("span", { className: "bold" }, checkInInstructions.accessCode)),
            react_1.default.createElement("div", { className: "instructions-fields" },
                react_1.default.createElement("span", null, "Apartamento: "),
                react_1.default.createElement("span", { className: "bold" }, checkInInstructions.alias)),
            react_1.default.createElement("div", { className: "instructions-fields" },
                react_1.default.createElement("span", null, "Wi-Fi:\u00A0"),
                react_1.default.createElement("span", { className: "bold" }, checkInInstructions.wifiName)),
            react_1.default.createElement("div", { className: "instructions-fields" },
                react_1.default.createElement("span", null, "Senha:\u00A0"),
                react_1.default.createElement("span", { className: "bold" }, checkInInstructions.wifiPass)))) : (react_1.default.createElement("div", { className: "instructions-fields" }, `Os dados para acesso serão liberados às ${hourLimit}h no dia do seu check-in. Mas não se preocupe! Você também
          receberá as instruções pelo e-mail cadastrado em sua reserva.`))));
};
exports.default = InstructionsCheckin;
